(ns frontend.view.modals.memo.events
  (:require [frontend.actions.deal :as deal-actions]))

(defn create-memo! [state oppo-id full? skip-blank-values?]
  (let [data (merge {:oppo/id oppo-id}
                    (when skip-blank-values?
                      {:skip-blank-values? true}))
        on-success! (fn [resp]
                      (let [body (:body resp)]
                        (swap! state assoc :processing-status :ok)
                        (swap! state assoc :download-url (:download-url body))))
        on-error! (fn [err]
                    (swap! state assoc :processing-status :failed))]
    (swap! state assoc :processing-status :processing)
    (if full?
      (deal-actions/*->create-full-memo data on-success! on-error!)
      (deal-actions/*->create-memo data on-success! on-error!))))
